import { Component, OnChanges } from '@angular/core';
import { CustomerManageService } from '../shared/customer-manage.service';
import { BaseComponent } from '../../shared/base-components/base.component';
import { CustomerRepresentative } from '../models/customer-representative.model';

@Component({
    selector: 'historical-customer-representative',
    templateUrl: './historical-customer-representative.html',
    inputs: ['customerNumberId']
})
export class HistoricalCustomerRepresentativeComponent extends BaseComponent implements OnChanges {
    public representatives: CustomerRepresentative[];
    public customerNumberId: number;

    constructor(private customerService: CustomerManageService) {
        super();
    }

    ngOnInit() {
    }

    ngOnChanges() {
        if (this.customerNumberId != null) {
            this.populateHistoricalRepresentatives(this.customerNumberId);
        }
    }

    populateHistoricalRepresentatives(customerNumberId: number) {

        this.customerService.getHistoricalCustomerRepresentatives(customerNumberId)
            .subscribe(result => {
                this.representatives = result;
            },
            e => {
                this.representatives = [];
                console.log('error', e);
            },
            () => {
            });
    }
}
